import React from 'react'
import Header from '../../../Components/Header'
import Footer from '../../../Components/Footer'

const PrivacyPolicy = () => {
  return (
    <>
      <Header/>
       <h6>Privacy policy page</h6>
      <Footer/>
    </>
  )
}

export default PrivacyPolicy
